import { stateSwitch } from '../stateSwitch';
import { addItemsVisibilityEventListeners } from './itemsVisibilityEvents';
import { spenttimeDebug as debug } from '../debug';
var containerMutationObserver = null;
/**
 * The handler that is executed when the container has been changed
 */
var containerMutationHandler = function () {
    addItemsVisibilityEventListeners();
};
/**
 * Adds container mutation event handler
 */
export var addContainerMutationEventListener = function () {
    if (!('MutationObserver' in window)) {
        return;
    }
    // Create an observer instance
    containerMutationObserver = new MutationObserver(containerMutationHandler);
    // Options for the observer (which mutations to observe)
    var config = { childList: true, subtree: true };
    // Start observing the target node for configured mutations
    containerMutationObserver.observe(stateSwitch.config.container.element, config);
    debug('[event] Container mutation event listener have been added');
};
/**
 * Removes container mutation event listener
 */
export var removeContainerMutationEventListener = function () {
    if (!('MutationObserver' in window)) {
        return;
    }
    // stop observing
    containerMutationObserver.disconnect();
    containerMutationObserver = null;
    debug('[event] Container mutation event listener have been disabled');
};
